import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import LineaGenetica from '../../components/lineaGenetica/LineaGenetica'
import {fetchLineaGenetica, recuperarDatosModal, duplicarDatosModal, cambiarEstado, onDelete, fetchFiltrarLinea} from '../../actions/lineaGenetica/lineaGenetica'

export function mapStateToProps (state) {
  return {
    lineaGenetica: {...state.lineaGenetica},
    formSimpleTable: state.form.simpleTable,
    numeroRegistrosPorPagina: state.common.numeroRegistrosPorPagina,
    paginaActual: state.common.paginaActual,
    auth: state.auth
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      fetchLineaGenetica,
      recuperarDatosModal,
      duplicarDatosModal,
      cambiarEstado,
      onDelete,
      fetchFiltrarLinea
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LineaGenetica))